<div class="ktbl-spacer-top-bottom"></div>

<div class="ktbl-button-container">
  <div class="ktbl-button-container-left">
    <button (click)="onClickQuelleHinzufuegen()" class="ktbl-button-primaer ktbl-button-width-m ktbl-button-width-m-c"
      type="button">
      <i class="fas fa-plus ktbl-icon-vertical-align"></i>
      Quelle hinzufügen...
    </button>
  </div>


  <div class="ktbl-button-container-right">
    <input type="file" class="ktbl-file-input" (change)="onFileSelected($event)" accept=".json" #fileUpload />
    <button (click)="fileUpload.click()" class="ktbl-button-primaer ktbl-button-width-m ktbl-button-width-m-c"
      type="button">
      <i class="fas fa-file-import ktbl-icon-vertical-align"></i>
      Betrieb importieren

    </button>

    <button (click)="onClickExportBetrieb()" class="ktbl-button-primaer ktbl-button-width-m ktbl-button-width-m-c"
      type="button">
      <i class="fas fa-file-export ktbl-icon-vertical-align"></i>
      Betrieb exportieren

      <i class="fas fa-info-circle ktbl-icon-info-select"
        matTooltip="Die exportierte Datei besitzt auch die derzeitigen Winddaten." matTooltipClass="tooltip-format"
        [matTooltipPosition]="tooltipPosition.value">
      </i>
    </button>
  </div>

</div>

<div class="ktbl-spacer-top-bottom"></div>

<mat-accordion class="ktbl-example-headers-align" multi>
  <mat-expansion-panel class="ktbl-accordeon-margin-top" [expanded]="ausgeklapptStallquellen == true" hideToggle="true"
    #panel1>
    <mat-expansion-panel-header>
      <mat-panel-title class="ktbl-mat-expension-panel-title">
        <span class="ktbl-expansion-panel-padding">Stallquellen</span>

        <div style="margin-left: auto;">
          <i *ngIf="!panel1.expanded" class="fa-solid fa-circle-caret-down ktbl-icon-mat-expansion"></i>
          <i *ngIf="panel1.expanded" class="fa-solid fa-circle-caret-up ktbl-icon-mat-expansion"></i>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="ktbl-scrollable-table">
      <table mat-table [dataSource]="dataAuswahlAnzeigeStallquelle" class="ktbl-table-breite-komplett">
        <ng-container *ngFor="let column of displayedColsStallquelle; let j = index" [matColumnDef]="column">
          <th mat-header-cell *matHeaderCellDef [ngClass]="{
              'ktbl-table-allgemein-200-width': column !== 'EMISSIONSMINDERUNGSMASSNAHME' && column !== 'EDIT_REMOVE' ,
              'ktbl-emissionsminderungsmassnahme-width': column === 'EMISSIONSMINDERUNGSMASSNAHME',
              'ktbl-edit-remove-width': column === 'EDIT_REMOVE',
              'ktbl-sub-table-header-base-neutral': true,
              'ktbl-typografie-reg-14-zwischenueberschrift': true              
            }">
            <ng-container *ngIf="column === 'BEZEICHNUNG'">Bezeichnung</ng-container>
            <ng-container *ngIf="column === 'TIERART'">Tierart</ng-container>
            <ng-container *ngIf="column === 'TIERKATEGORIE'">Tierkategorie</ng-container>
            <ng-container *ngIf="column === 'HALTUNGSVERFAHREN'">Haltungsverfahren</ng-container>
            <ng-container *ngIf="column === 'ANZAHL_TIERE'">Anzahl Tiere</ng-container>
            <ng-container *ngIf="column === 'EINZELTIERMASSE_GV_TIER'">Einzeltiermasse in GV/Tier</ng-container>
            <ng-container *ngIf="column === 'GESAMTTIERMASSE_GV'">Gesamttiermasse in GV</ng-container>
            <ng-container *ngIf="column === 'EMISSIONSFAKTOR_GE_GV'">Emissionsfaktor in GE/(s GV)</ng-container>
            <ng-container *ngIf="column === 'WIRKUNGSGRAD'">Wirkungsgrad in %</ng-container>
            <ng-container *ngIf="column === 'EMISSION_GE'">Emission in GE/s</ng-container>
            <ng-container *ngIf="column === 'GEWICHTUNGSFAKTOR'">Gewichtungsfaktor</ng-container>
            <ng-container *ngIf="column === 'EMISSIONSMINDERUNGSMASSNAHME'">Emissionsminderungsmassnahme</ng-container>
            <ng-container *ngIf="column === 'X_KOORDINATE'">X-Koordinate in m</ng-container>
            <ng-container *ngIf="column === 'Y_KOORDINATE'">Y-Koordinate in m</ng-container>
            <ng-container *ngIf="column === 'EDIT_REMOVE'"></ng-container>
          </th>

          <td mat-cell *matCellDef="let entry; let i = index" [ngClass]="{
                'ktbl-table-content-normal': i % 2 === 0,
                'ktbl-table-content-invert': i % 2 !== 0,
                'ktbl-table-content-border': j === 0,


                'ktbl-table-cell-no-padding-left': column === 'EDIT_REMOVE',
                'ktbl-table-cell-left': column === 'BEZEICHNUNG' || column === 'TIERART' || column === 'TIERKATEGORIE' || column === 'HALTUNGSVERFAHREN' || column === 'EMISSIONSMINDERUNGSMASSNAHME',
                'ktbl-table-cell-right': column === 'ANZAHL_TIERE' || column === 'EINZELTIERMASSE_GV_TIER' || column === 'GESAMTTIERMASSE_GV' || column === 'EINZELTIERMASSE_GV_TIER' || column === 'EMISSIONSFAKTOR_GE_GV' ||
                column === 'WIRKUNGSGRAD' || column === 'GEWICHTUNGSFAKTOR' || column === 'EMISSION_GE' || column === 'X_KOORDINATE' || column === 'Y_KOORDINATE'
              }">
            <ng-container *ngIf="column === 'BEZEICHNUNG'">{{ entry.bezeichnung }}</ng-container>
            <ng-container *ngIf="column === 'TIERART'">{{ entry.tierart }}</ng-container>
            <ng-container *ngIf="column === 'TIERKATEGORIE'">{{ entry.tierkategorie }}</ng-container>
            <ng-container *ngIf="column === 'HALTUNGSVERFAHREN'">{{ entry.haltungsverfahren }}</ng-container>
            <ng-container *ngIf="column === 'ANZAHL_TIERE'">{{ entry.anzahlTiere }}</ng-container>
            <ng-container *ngIf="column === 'EINZELTIERMASSE_GV_TIER'">{{entry.einzeltiermasseGv | number : "1.4-4" :
              "de-DE"}}</ng-container>
            <ng-container *ngIf="column === 'GESAMTTIERMASSE_GV'">{{entry.gesamttiermasseGv | number : "1.1-1" :
              "de-DE"}}</ng-container>
            <ng-container *ngIf="column === 'EMISSIONSFAKTOR_GE_GV'">{{ entry.emissionsfaktorGeGv }}</ng-container>
            <ng-container *ngIf="column === 'WIRKUNGSGRAD'">{{ entry.wirkungsgrad | number : "1.2-2" : "de-DE"
              }}</ng-container>
            <ng-container *ngIf="column === 'EMISSION_GE'">{{ entry.emissionGe | number : "1.0-0" : "de-DE"
              }}</ng-container>
            <ng-container *ngIf="column === 'GEWICHTUNGSFAKTOR'">{{ entry.gewichtungsfaktor | number : "1.2-2" : "de-DE"
              }}</ng-container>
            <ng-container *ngIf="column === 'EMISSIONSMINDERUNGSMASSNAHME'">{{ entry.emissionsminderungsmassnahme
              }}</ng-container>
            <ng-container *ngIf="column === 'X_KOORDINATE'">{{ entry.xKoordinate }}</ng-container>
            <ng-container *ngIf="column === 'Y_KOORDINATE'">{{ entry.yKoordinate }}</ng-container>
            <ng-container *ngIf="column === 'EDIT_REMOVE'">
              <div class="ktbl-button-container-zentriert">
                <button class="ktbl-button-tertiaer ktbl-button-icon-s" type="button" matTooltip="Editieren"
                  (click)="onClickEditieren(1, i)" [matTooltipPosition]="tooltipPosition.value"
                  matTooltipClass="tooltip-format"> <i class="fas fa-edit ktbl-icon-vertical-align"></i></button>
                <button class="ktbl-button-tertiaer ktbl-button-icon-s" type="button" matTooltip="Entfernen"
                  (click)="onClickEntfernen(1, i)" [matTooltipPosition]="tooltipPosition.value"
                  matTooltipClass="tooltip-format"> <i class="fas fa-remove ktbl-icon-vertical-align"></i></button>
              </div>
            </ng-container>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColsStallquelle"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColsStallquelle"></tr>
      </table>
    </div>
  </mat-expansion-panel>


  <mat-expansion-panel class="ktbl-accordeon-margin-top" [expanded]="ausgeklapptFlaechenquellen == true"
    hideToggle="true" #panel2>
    <mat-expansion-panel-header>
      <mat-panel-title class="ktbl-mat-expension-panel-title">
        <span class="ktbl-expansion-panel-padding">
          Flächenquellen
        </span>

        <div style="margin-left: auto;">
          <i *ngIf="!panel2.expanded" class="fa-solid fa-circle-caret-down ktbl-icon-mat-expansion"></i>
          <i *ngIf="panel2.expanded" class="fa-solid fa-circle-caret-up ktbl-icon-mat-expansion"></i>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="ktbl-scrollable-table">
      <table mat-table [dataSource]="dataAuswahlAnzeigeFlaechenquelle" class="ktbl-table-breite-komplett">
        <ng-container *ngFor="let column of displayedColsFlaechenquelle; let j = index" [matColumnDef]="column">
          <th mat-header-cell *matHeaderCellDef [ngClass]="{
              'ktbl-table-allgemein-200-width': column !== 'EMISSIONSMINDERUNGSMASSNAHME' && column !== 'EDIT_REMOVE' ,
              'ktbl-emissionsminderungsmassnahme-width': column === 'EMISSIONSMINDERUNGSMASSNAHME',
              'ktbl-edit-remove-width': column === 'EDIT_REMOVE',
              'ktbl-sub-table-header-base-neutral': true,
              'ktbl-typografie-reg-14-zwischenueberschrift': true
          }">
            <ng-container *ngIf="column === 'BEZEICHNUNG'">Bezeichnung</ng-container>
            <ng-container *ngIf="column === 'FLAECHENQUELLART'">Flächenquellenart</ng-container>
            <ng-container *ngIf="column === 'DURCHMESSER'">Durchmesser in m</ng-container>
            <ng-container *ngIf="column === 'LAENGE_HOEHE'"> Länge/Höhe in m</ng-container>
            <ng-container *ngIf="column === 'BREITE'"> Breite in m</ng-container>
            <ng-container *ngIf="column === 'FLAECHE'"> Fläche in m²</ng-container>
            <ng-container *ngIf="column === 'EMISSIONSFAKTOR_GE_GV'"> Emissionsfaktor in GE/(s GV)</ng-container>
            <ng-container *ngIf="column === 'EMISSIONSMINDERUNGSMASSNAHME'"> Emissionsminderungsmassnahme</ng-container>
            <ng-container *ngIf="column === 'WIRKUNGSGRAD'"> Wirkungsgrad in %</ng-container>
            <ng-container *ngIf="column === 'GEWICHTUNGSFAKTOR'"> Gewichtungsfaktor</ng-container>
            <ng-container *ngIf="column === 'EMISSION_GE'"> Emission in GE/s</ng-container>
            <ng-container *ngIf="column === 'X_KOORDINATE'"> X-Koordinate in m</ng-container>
            <ng-container *ngIf="column === 'Y_KOORDINATE'"> Y-Koordinate in m</ng-container>
            <ng-container *ngIf="column === 'EDIT_REMOVE'"></ng-container>
          </th>

          <td mat-cell *matCellDef="let entry; let i = index" [ngClass]="{
            'ktbl-table-content-normal': i % 2 === 0,
            'ktbl-table-content-invert': i % 2 !== 0,
            'ktbl-table-content-border': j === 0,            
            'ktbl-table-cell-no-padding-left': column === 'EDIT_REMOVE',
            'ktbl-table-cell-left': column === 'BEZEICHNUNG' || column === 'FLAECHENQUELLART' || column === 'DURCHMESSER'  || column === 'EMISSIONSMINDERUNGSMASSNAHME',
            'ktbl-table-cell-right': column === 'DURCHMESSER' || column === 'LAENGE_HOEHE' || column === 'BREITE' || column === 'FLAECHE' || column === 'EMISSIONSFAKTOR_GE_GV' || column === 'WIRKUNGSGRAD' || column === 'GEWICHTUNGSFAKTOR' ||
            column === 'EMISSION_GE' || column === 'X_KOORDINATE' || column === 'Y_KOORDINATE'
          }">
            <ng-container *ngIf="column === 'BEZEICHNUNG'">{{ entry.bezeichnung }}</ng-container>
            <ng-container *ngIf="column === 'FLAECHENQUELLART'">{{ entry.flaechenquellenart }}</ng-container>
            <ng-container *ngIf="column === 'DURCHMESSER'"> {{ entry.durchmesser | number : "1.1-1" :
              "de-DE"}}</ng-container>
            <ng-container *ngIf="column === 'LAENGE_HOEHE'"> {{ entry.laengeHoehe | number : "1.1-1" :
              "de-DE"}}</ng-container>
            <ng-container *ngIf="column === 'BREITE'"> {{ entry.breite | number : "1.1-1" : "de-DE"}}</ng-container>
            <ng-container *ngIf="column === 'FLAECHE'"> {{ entry.flaeche | number : "1.1-1" : "de-DE"}}</ng-container>
            <ng-container *ngIf="column === 'EMISSIONSFAKTOR_GE_GV'"> {{ entry.emissionsfaktorGeGv }}</ng-container>
            <ng-container *ngIf="column === 'EMISSIONSMINDERUNGSMASSNAHME'"> {{ entry.emissionsminderungsmassnahme
              }}</ng-container>
            <ng-container *ngIf="column === 'WIRKUNGSGRAD'"> {{ entry.wirkungsgrad | number : "1.2-2" : "de-DE"
              }}</ng-container>
            <ng-container *ngIf="column === 'GEWICHTUNGSFAKTOR'"> {{ entry.gewichtungsfaktor | number : "1.2-2" :
              "de-DE" }}</ng-container>
            <ng-container *ngIf="column === 'EMISSION_GE'"> {{ entry.emissionGe | number : "1.0-0" : "de-DE"
              }}</ng-container>
            <ng-container *ngIf="column === 'X_KOORDINATE'"> {{ entry.xKoordinate }}</ng-container>
            <ng-container *ngIf="column === 'Y_KOORDINATE'"> {{ entry.yKoordinate }}</ng-container>
            <ng-container *ngIf="column === 'EDIT_REMOVE'">
              <div class="ktbl-button-container-zentriert">
                <button class="ktbl-button-tertiaer ktbl-button-icon-s" type="button" matTooltip="Editieren"
                  (click)="onClickEditieren(2, i)" [matTooltipPosition]="tooltipPosition.value"
                  matTooltipClass="tooltip-format"> <i class="fas fa-edit ktbl-icon-vertical-align"></i></button>
                <button class="ktbl-button-tertiaer ktbl-button-icon-s" type="button" matTooltip="Entfernen"
                  (click)="onClickEntfernen(2, i)" [matTooltipPosition]="tooltipPosition.value"
                  matTooltipClass="tooltip-format"> <i class="fas fa-remove ktbl-icon-vertical-align"></i></button>
              </div>
            </ng-container>
          </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColsFlaechenquelle"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColsFlaechenquelle"></tr>
      </table>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel class="ktbl-accordeon-margin-top" [expanded]="ausgeklapptFlaechenquellen == true"
    hideToggle="true" #panel3>
    <mat-expansion-panel-header>
      <mat-panel-title class="ktbl-mat-expension-panel-title">
        <span class="ktbl-expansion-panel-padding">
          Sonstige Quellen
        </span>

        <div style="margin-left: auto;">
          <i *ngIf="!panel3.expanded" class="fa-solid fa-circle-caret-down ktbl-icon-mat-expansion"></i>
          <i *ngIf="panel3.expanded" class="fa-solid fa-circle-caret-up ktbl-icon-mat-expansion"></i>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="ktbl-scrollable-table">
      <table mat-table [dataSource]="dataAuswahlAnzeigeSonstigeQuelle" class="ktbl-table-breite-komplett">
        <ng-container *ngFor="let column of displayedColsSonstigeQuelle; let j = index" [matColumnDef]="column">
          <th mat-header-cell *matHeaderCellDef [ngClass]="{
              'ktbl-table-allgemein-200-width':  column !== 'EDIT_REMOVE' && column !== 'EMPTY', 
              'ktbl-edit-remove-width': column === 'EDIT_REMOVE',
              'ktbl-sub-table-header-base-neutral': true,
              'ktbl-typografie-reg-14-zwischenueberschrift': true
          }">
            <ng-container *ngIf="column === 'BEZEICHNUNG'">Bezeichnung</ng-container>
            <ng-container *ngIf="column === 'GEWICHTUNGSFAKTOR'">Gewichtungsfaktor</ng-container>
            <ng-container *ngIf="column === 'EMISSION_GE'"> Emission in GE/s</ng-container>
            <ng-container *ngIf="column === 'X_KOORDINATE'"> X-Koordinate in m</ng-container>
            <ng-container *ngIf="column === 'Y_KOORDINATE'"> Y-Koordinate in m</ng-container>
            <ng-container *ngIf="column === 'EDIT_REMOVE'"></ng-container>
          </th>

          <td mat-cell *matCellDef="let entry; let i = index" [ngClass]="{
            'ktbl-table-content-normal': i % 2 === 0,
            'ktbl-table-content-invert': i % 2 !== 0,
            'ktbl-table-content-border': j === 0,            
            'ktbl-table-cell-no-padding-left': column === 'EDIT_REMOVE',
            'ktbl-table-cell-left': column === 'BEZEICHNUNG',
            'ktbl-table-cell-right': column !== 'BEZEICHNUNG' && column !== 'EDIT_REMOVE'
          }">
            <ng-container *ngIf="column === 'BEZEICHNUNG'">{{ entry.bezeichnung }}</ng-container>
            <ng-container *ngIf="column === 'GEWICHTUNGSFAKTOR'"> {{ entry.gewichtungsfaktor | number : "1.2-2" :
              "de-DE" }}</ng-container>
            <ng-container *ngIf="column === 'EMISSION_GE'"> {{ entry.emissionGe | number : "1.0-0" : "de-DE"
              }}</ng-container>
            <ng-container *ngIf="column === 'X_KOORDINATE'"> {{ entry.xKoordinate }}</ng-container>
            <ng-container *ngIf="column === 'Y_KOORDINATE'"> {{ entry.yKoordinate }}</ng-container>
            <ng-container *ngIf="column === 'EDIT_REMOVE'">
              <div class="ktbl-button-container-zentriert">
                <button class="ktbl-button-tertiaer ktbl-button-icon-s" type="button" matTooltip="Editieren"
                  (click)="onClickEditieren(3, i)" [matTooltipPosition]="tooltipPosition.value"
                  matTooltipClass="tooltip-format"> <i class="fas fa-edit ktbl-icon-vertical-align"></i></button>
                <button class="ktbl-button-tertiaer ktbl-button-icon-s" type="button" matTooltip="Entfernen"
                  (click)="onClickEntfernen(3, i)" [matTooltipPosition]="tooltipPosition.value"
                  matTooltipClass="tooltip-format"> <i class="fas fa-remove ktbl-icon-vertical-align"></i></button>




              </div>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColsSonstigeQuelle"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColsSonstigeQuelle"></tr>
      </table>
    </div>
  </mat-expansion-panel>
</mat-accordion>
<div class="ktbl-spacer-top-bottom"></div>

<h4>
  Emission und Emissionsschwerpunkt der gesamten Tierhaltungsanlage
</h4>

<div class="ktbl-labels-block">
  <p>
    <mat-label [style.color]="
      ergebnisQuelleGes?.gesamtemissionen != null
      && ergebnisQuelleGes.gesamtemissionen > maxGesamtemissionGeS
        ? GlobalConstantsColor.RED
        : null
    ">
      Gesamtemission:
      {{
      ergebnisQuelleGes?.gesamtemissionen != null
      ? (ergebnisQuelleGes.gesamtemissionen | number:'1.0-0':'de-DE')
      : '-'
      }} GE/s

      <i *ngIf="
        ergebnisQuelleGes?.gesamtemissionen != null
        && ergebnisQuelleGes.gesamtemissionen > maxGesamtemissionGeS
      " class="fas fa-info-circle ktbl-icon-info-select" [matTooltip]="
        'Die Gesamtemission sollte < '
        + (maxGesamtemissionGeS | number:'1.0-0':'de-DE')
        + ' GE/s sein.'
      " matTooltipClass="tooltip-format" [matTooltipPosition]="tooltipPosition.value">
      </i>
    </mat-label>
  </p>

  <p>
    <mat-label>
      Emissionsschwerpunkt (X<sub>ES</sub>, Y<sub>ES</sub>):
      {{
      ergebnisQuelleGes?.emissionsschwerpunktX != null
      ? (ergebnisQuelleGes.emissionsschwerpunktX | number:'1.0-0':'de-DE')
      : '-'
      }} m,
      {{
      ergebnisQuelleGes?.emissionsschwerpunktY != null
      ? (ergebnisQuelleGes.emissionsschwerpunktY | number:'1.0-0':'de-DE')
      : '-'
      }} m
    </mat-label>
  </p>
</div>

<h4>
  Zusatzabstand und Gewichtungsfaktor der gesamten Tierhaltungsanlage
  prüfen und ggf. ändern
  <i class="fas fa-info-circle ktbl-icon-info-select"
    matTooltip="Bei Änderung der Quellen werden diese Werte automatisch aktualisiert. Wenn ein Wert per Hand eingetragen wird, wird dieser bei Änderung der Quelle auf den berechneten zurückgesetzt."
    matTooltipClass="tooltip-format" [matTooltipPosition]="tooltipPosition.value">
  </i>
</h4>

<div class="ktbl-row-mehrspaltig-2-elemente">
  <mat-form-field class="ktbl-input-box" appearance="fill">
    <mat-label>Zusatzabstand d in m </mat-label>

    <input matInput required [errorStateMatcher]="matcher" [formControl]="zusatzabstandFormControl" />
    <mat-error *ngIf="zusatzabstandFormControl.invalid">
      {{ formControlGanzZahlLaeng4OderKomma1NumberWarning }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="ktbl-input-box" appearance="fill">
    <mat-label>Maximaler Gewichtungsfaktor f nach Anhang 7 TA Luft </mat-label>

    <input matInput required [errorStateMatcher]="matcher" [formControl]="gewichtungsfaktorFormControl" />
    <mat-error
      *ngIf="gewichtungsfaktorFormControl.invalid">
      {{ formControlGanzZahlLaeng4OderKomma2NumberWarning }}
    </mat-error>
  </mat-form-field>
</div>